module.exports = __webpack_public_path__ + "img/37ne.b23ce538.svg";